export default __webpack_public_path__ + "static/media/payment-method-card.18fcc666.svg";